import { Info } from "lucide-react";

interface LocationFallbackBannerProps {
  onTap: () => void;
}

export const LocationFallbackBanner = ({ onTap }: LocationFallbackBannerProps) => {
  return (
    <div
      className="fixed bottom-20 left-0 right-0 z-40 flex cursor-pointer items-center justify-center bg-primary p-2 text-primary-foreground"
      onClick={onTap}
    >
      <span className="text-xs">
        位置情報が未取得のため、名古屋駅（代表地点）からの距離計算です
      </span>
      <Info className="ml-2 h-3 w-3" />
    </div>
  );
};
